import React from 'react';
import { motion } from 'framer-motion';

const Hero = ({ data, personal }) => {
  return (
    <section className="min-h-screen flex items-center justify-center px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="inline-block bg-stone-100 px-4 py-2 rounded-full border border-stone-200 mb-6"
            >
              <span className="text-amber-700 text-sm font-medium">{data.badge}</span>
            </motion.div>

            <h1 className="text-5xl lg:text-7xl font-bold text-stone-800 mb-6 leading-tight">
              {personal.name}
            </h1>

            <h2 className="text-2xl lg:text-3xl text-stone-600 mb-6 font-light">
              {data.subtitle}
            </h2>

            <p className="text-lg text-stone-500 mb-8 leading-relaxed">
              {data.description}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative"
          >
            <div className="relative z-10">
              <img
                src={personal.image}
                alt={personal.name}
                className="w-full max-w-md mx-auto rounded-2xl shadow-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-amber-600/10 to-stone-600/10 rounded-2xl"></div>
            </div>
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-gradient-to-br from-amber-600/20 to-stone-600/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-4 -left-4 w-72 h-72 bg-gradient-to-tr from-stone-600/20 to-amber-600/20 rounded-full blur-3xl"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;